import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import "../index.css";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const getUserList = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/user-list`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        const parseRes = await response.json();
        if (parseRes.success) {
          console.log(parseRes.Result);
          setUsers(parseRes.Result);
          setFilteredUsers(parseRes.Result);
        } else {
          console.log("Failed to fetch user list");
        }
      } catch (error) {
        console.error("Error fetching user list:", error);
      }
    };

    getUserList();
  }, []); // Empty dependency array for initial fetch

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
    const filteredUsers = users.filter((user) =>
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(filteredUsers);
  };

  const handleDelete = async (id) => {
    console.log("inside the handledelete: ", id);
    axios
      .delete(`${process.env.REACT_APP_API_URL}/auth/delete-user-by-id/` + id, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success(response.data.message);
          navigate("/");
          navigate(-1);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleReactivate = async (id) => {
    console.log("inside the handlereactivate: ", id);
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/auth/reactivate-user-by-id/` + id,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        if (response.data.success) {
          toast.success(response.data.message);
          navigate("/");
          navigate(-1);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <Layout>
      <div className="px-5 mt-3">
        <div className="d-flex justify-content-center">
          <h3 className="page-title">Liste d'utilisateurs</h3>
        </div>
        <div className="mt-3">
          <div className="row justify-content-end mb-3">
            <div className="col-12 col-sm-6 col-md-4">
              <input
                type="text"
                placeholder="Email"
                value={searchTerm}
                onChange={handleSearchChange}
                className="form-control"
              />
            </div>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th className="category">Noms</th>
                <th className="category">Email</th>
                <th className="category">Type</th>
                <th className="category">Crée le</th>
                <th className="category">Statut</th>
                <th className="category">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user) => (
                <tr
                  key={user.created_at}
                  className={user.isactive ? "" : "inactive-row"}
                >
                  <td>
                    {user.prenom} {user.nom}
                  </td>
                  <td>{user.email}</td>
                  <td>{user.type}</td>
                  <td>
                    {new Date(user.created_at).toLocaleString("fr-FR", {
                      timeZone: "UTC",
                    })}
                  </td>
                  <td>{user.isactive === true ? "Actif" : "Inactif"}</td>
                  <td>
                    {/* Pass user_id as a parameter in the URL */}
                    <Link to={`/user-detail/${user.user_id}`}>
                      <button
                        className="btn btn-secondary"
                        style={{
                          backgroundColor: "#005555",
                          marginRight: "2px",
                        }}
                      >
                        Details
                      </button>
                    </Link>
                    {user.isactive ? (
                      <button
                        type="button"
                        onClick={() => handleDelete(user.user_id)}
                        className="btn btn-primary px-2"
                        style={{ backgroundColor: "#bc0000" }}
                      >
                        Desactiver
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={() => handleReactivate(user.user_id)}
                        className="btn btn-primary px-2"
                        style={{ backgroundColor: "#00bc00" }}
                      >
                        Reactiver
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Link to="/add-user">
            <button
              style={{ backgroundColor: "#AF47E8" }}
              className="btn btn-primary px-3"
            >
              Ajouter un utilisateur
            </button>
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default UserList;
